var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"googleChart"},[_c('GChart',{staticClass:"ggChart",attrs:{"settings":{ packages: ['corechart'], language: 'fr' },"type":"ComboChart","data":_vm.chartDatas,"options":_vm.chartOptions,"resizeDebounce":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }